export const baseUrl = import.meta.url

export const locales = {
    "lij-IT": "./locales/lij-IT.json.gz",
    "lv-LV": "./locales/lv-LV.json.gz",
    "km-KH": "./locales/km-KH.json.gz",
    "pa-PK": "./locales/pa-PK.json.gz",
    "pl-PL": "./locales/pl-PL.json.gz",
    "hu-HU": "./locales/hu-HU.json.gz",
    "mn-MN": "./locales/mn-MN.json.gz",
    "es-ES": "./locales/es-ES.json.gz",
    "nb-NO": "./locales/nb-NO.json.gz",
    "es-CL": "./locales/es-CL.json.gz",
    "zh-CN": "./locales/zh-CN.json.gz",
    "da-DK": "./locales/da-DK.json.gz",
    "bal-PK": "./locales/bal-PK.json.gz",
    "hr-HR": "./locales/hr-HR.json.gz",
    "et-EE": "./locales/et-EE.json.gz",
    "fr-CA": "./locales/fr-CA.json.gz",
    "bg-BG": "./locales/bg-BG.json.gz",
    "ro-RO": "./locales/ro-RO.json.gz",
    "ar": "./locales/ar.json.gz",
    "eu": "./locales/eu.json.gz",
    "he-IL": "./locales/he-IL.json.gz",
    "hi-IN": "./locales/hi-IN.json.gz",
    "cs-CZ": "./locales/cs-CZ.json.gz",
    "nn-NO": "./locales/nn-NO.json.gz",
    "de-DE": "./locales/de-DE.json.gz",
    "fi-FI": "./locales/fi-FI.json.gz",
    "de-CH": "./locales/de-CH.json.gz",
    "tr-TR": "./locales/tr-TR.json.gz",
    "sl-SI": "./locales/sl-SI.json.gz",
    "sr-Cyrl-RS": "./locales/sr-Cyrl-RS.json.gz",
    "gl-ES": "./locales/gl-ES.json.gz",
    "cy-GB": "./locales/cy-GB.json.gz",
    "ru-RU": "./locales/ru-RU.json.gz",
    "en-US": "./locales/en-US.json.gz",
    "sv-SE": "./locales/sv-SE.json.gz",
    "it-IT": "./locales/it-IT.json.gz",
    "es-MX": "./locales/es-MX.json.gz",
    "zh-TW": "./locales/zh-TW.json.gz",
    "nl-NL": "./locales/nl-NL.json.gz",
    "fr-FR": "./locales/fr-FR.json.gz",
    "vi-VN": "./locales/vi-VN.json.gz",
    "tl-PH": "./locales/tl-PH.json.gz",
    "de-AT": "./locales/de-AT.json.gz",
    "brh-PK": "./locales/brh-PK.json.gz",
    "is-IS": "./locales/is-IS.json.gz",
    "ca-AD": "./locales/ca-AD.json.gz",
    "en-GB": "./locales/en-GB.json.gz",
    "id-ID": "./locales/id-ID.json.gz",
    "pt-BR": "./locales/pt-BR.json.gz",
    "ja-JP": "./locales/ja-JP.json.gz",
    "la": "./locales/la.json.gz",
    "uk-UA": "./locales/uk-UA.json.gz",
    "hy-AM": "./locales/hy-AM.json.gz",
    "sr-Latn-RS": "./locales/sr-Latn-RS.json.gz",
    "sk-SK": "./locales/sk-SK.json.gz",
    "ms-MY": "./locales/ms-MY.json.gz",
    "el-GR": "./locales/el-GR.json.gz",
    "th-TH": "./locales/th-TH.json.gz",
    "pt-PT": "./locales/pt-PT.json.gz",
    "af-ZA": "./locales/af-ZA.json.gz",
    "lt-LT": "./locales/lt-LT.json.gz",
    "fa-IR": "./locales/fa-IR.json.gz",
    "ko-KR": "./locales/ko-KR.json.gz",}